export const collabsAndCommunity = [
  { id: 1, name: 'Alphabot', image: '/images/home/collabs/alphabot.png' },
  { id: 2, name: 'Analog', image: '/images/home/collabs/analog.png' },
  {
    id: 3,
    name: 'Anya frens',
    image: '/images/home/collabs/anya_frens.png',
  },
  { id: 4, name: 'Apelist', image: '/images/home/collabs/apelist.png' },
  { id: 5, name: 'Ash hub', image: '/images/home/collabs/ash_hub.png' },
  {
    id: 6,
    name: 'Blvck paris',
    image: '/images/home/collabs/blvck_paris.png',
  },
  { id: 7, name: 'Circle', image: '/images/home/collabs/circle.png' },
  {
    id: 8,
    name: 'Connectivity',
    image: '/images/home/collabs/connectivity.png',
  },
  { id: 9, name: 'Clokies', image: '/images/home/collabs/clokies.png' },
  {
    id: 10,
    name: 'CoinTelegraph',
    image: '/images/home/collabs/cointelegraph.png',
  },
  {
    id: 11,
    name: 'Cricket fly',
    image: '/images/home/collabs/cricket_fly.png',
  },
  {
    id: 12,
    name: 'Degen dao',
    image: '/images/home/collabs/degen_dao.png',
  },
  { id: 13, name: 'Dislands', image: '/images/home/collabs/dislands.png' },
  { id: 14, name: 'Embassy', image: '/images/home/collabs/embassy.png' },
  { id: 15, name: 'Gate', image: '/images/home/collabs/gate.png' },
  {
    id: 16,
    name: 'Generative dungeon',
    image: '/images/home/collabs/generative_dungeon.png',
  },
  {
    id: 17,
    name: 'Grind hub',
    image: '/images/home/collabs/grind_hub.png',
  },
  {
    id: 18,
    name: 'Hexagon labs',
    image: '/images/home/collabs/hexagon_labs.png',
  },
  {
    id: 19,
    name: 'Intoverse',
    image: '/images/home/collabs/intoverse.png',
  },
  {
    id: 20,
    name: 'Jerry alpha',
    image: '/images/home/collabs/jerry_alpha.png',
  },
  {
    id: 21,
    name: 'Life’s Meta',
    image: '/images/home/collabs/lifes_meta.png',
  },
  {
    id: 22,
    name: 'Magic store',
    image: '/images/home/collabs/magic_store.png',
  },
  {
    id: 23,
    name: 'Metamerge',
    image: '/images/home/collabs/metamerge.png',
  },
  {
    id: 24,
    name: 'Miningverse',
    image: '/images/home/collabs/miningverse.png',
  },
  {
    id: 25,
    name: 'Nft bridge',
    image: '/images/home/collabs/nft_bridge.png',
  },
  { id: 26, name: 'Nft hub', image: '/images/home/collabs/nft_hub.png' },
  {
    id: 27,
    name: 'Nunu spirits',
    image: '/images/home/collabs/nunu_spirits.png',
  },
  { id: 28, name: 'Obvious', image: '/images/home/collabs/obvious.png' },
  {
    id: 29,
    name: 'Ordinal eggs',
    image: '/images/home/collabs/ordinal_eggs.png',
  },
  {
    id: 30,
    name: 'Raiders lab',
    image: '/images/home/collabs/raiders_lab.png',
  },
  {
    id: 31,
    name: 'Sharp trade',
    image: '/images/home/collabs/sharp_trade.png',
  },
  { id: 32, name: 'Skale', image: '/images/home/collabs/skale.png' },
  { id: 33, name: 'Syndika', image: '/images/home/collabs/syndika.png' },
  {
    id: 34,
    name: '$pirit gate$',
    image: '/images/home/collabs/spirit_gates.png',
  },
  { id: 35, name: 'Tangerine', image: '/images/home/collabs/tangerin.png' },
  {
    id: 36,
    name: 'Ton capital',
    image: '/images/home/collabs/ton_capital.png',
  },
  {
    id: 37,
    name: 'Top tier signal',
    image: '/images/home/collabs/top_tier_signal.png',
  },
  {
    id: 38,
    name: 'Tropa da rih',
    image: '/images/home/collabs/tropa_da_rih.png',
  },
  {
    id: 39,
    name: 'Ultiverse',
    image: '/images/home/collabs/ultiverse.png',
  },
  {
    id: 40,
    name: 'Versa web3',
    image: '/images/home/collabs/versa_web3.png',
  },
  { id: 41, name: 'Word4zz', image: '/images/home/collabs/word4zz.png' },
  {
    id: 42,
    name: 'Xcelerator',
    image: '/images/home/collabs/xcelerator.png',
  },
  { id: 43, name: 'Xdao', image: '/images/home/collabs/xdao.png' },
  { id: 44, name: 'Xhashtag', image: '/images/home/collabs/xhashtag.png' },
  { id: 45, name: 'Zkgames', image: '/images/home/collabs/zkgames.png' },
  { id: 46, name: 'Zooverse', image: '/images/home/collabs/zooverse.png' },
]
